/**
 * 统计各个模块的待处理事项
 */

import { getMyFeedbackStat } from "@/service/cms/feedback";
import { getOmpStat } from "@/service/cms/stat";
import store from "@/store";

export const useCount = () => {
    // 统计我的待处理反馈工单
    // 包含协同的、被指派的，状态限制为1和2的
    // 统计未读的通知消息
    const countMyFeedback = async () => {
        await getMyFeedbackStat().then((res) => {
            const data = res.data.data;
            store.commit("app/SET_COUNTS", {
                key: "common-account-message",
                value: data?.message || 0,
            });
            store.commit("app/SET_COUNTS", {
                key: "common-account-feedback",
                value: data?.feedback || 0,
            });
        });
    };

    // 获取运营管理平台统计
    const countOmpStat = async () => {
        await getOmpStat().then((res) => {
            const counts = res.data.data?.counts || {};
            Object.keys(counts).forEach((key) => {
                store.commit("app/SET_COUNTS", {
                    key,
                    value: counts[key] || 0,
                });
            });
        });
    };

    // 兼容支持中心页面的局部刷新调用
    const countSupport = countOmpStat;
    const countRecruitment = countOmpStat;

    return {
        countMyFeedback,
        countOmpStat,
        countSupport,
        countRecruitment,
    };
};
